import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { loginUser } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { LogIn, Eye, EyeOff } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_c0b7ab56-dc9b-46c6-8c6a-5be1ac8c634e/artifacts/1y3fjfg2_AMAZONIA%20-%20LOGO%402x.png";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await loginUser(form);
      login(res.data.token, res.data.user);
      if (res.data.user.role === 'admin') navigate('/admin');
      else if (res.data.user.status === 'validated') navigate('/dashboard');
      else navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur de connexion');
    }
    setLoading(false);
  };

  return (
    <div data-testid="login-page" className="min-h-[80vh] flex items-center justify-center py-12 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Amazonia" className="h-16 mx-auto mb-4" />
          <h1 className="text-2xl font-extrabold text-[#111] tracking-tight">Connexion</h1>
          <p className="text-sm text-black/50 mt-1">Accédez à votre espace professionnel</p>
        </div>

        <div className="border border-black/10 p-8">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wider text-black/50 font-semibold block mb-1.5">Email</label>
              <input
                type="email" required value={form.email} onChange={(e) => setForm({...form, email: e.target.value})}
                data-testid="login-email"
                className="w-full px-3 py-2.5 text-sm border border-black/15 focus:ring-2 focus:ring-[#00A5FF] focus:border-transparent outline-none transition-shadow duration-200"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-black/50 font-semibold block mb-1.5">Mot de passe</label>
              <div className="relative">
                <input
                  type={showPw ? 'text' : 'password'} required value={form.password} onChange={(e) => setForm({...form, password: e.target.value})}
                  data-testid="login-password"
                  className="w-full px-3 py-2.5 text-sm border border-black/15 focus:ring-2 focus:ring-[#00A5FF] focus:border-transparent outline-none transition-shadow duration-200 pr-10"
                />
                <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-black/30 hover:text-black/60">
                  {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>
            {error && <p data-testid="login-error" className="text-sm text-[#E8231B]">{error}</p>}
            <button
              type="submit" disabled={loading}
              data-testid="login-submit"
              className="w-full flex items-center justify-center gap-2 py-3 bg-[#00A5FF] text-white font-semibold text-sm rounded-sm hover:bg-[#0090e0] disabled:opacity-50 transition-colors duration-200"
            >
              <LogIn size={16} />
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
          <div className="mt-6 text-center">
            <p className="text-sm text-black/50">
              Pas encore de compte ?{' '}
              <Link to="/register" className="text-[#00A5FF] font-semibold hover:underline">Créer un compte Pro</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
